module.exports = __webpack_public_path__ + "img/00 banner.46956f9f.png";